/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_L1_NInputs */

const en_mk_sec_pg_l1_n = /** @type {(inputs: Mk_Sec_Pg_L1_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tested automatically every release: 133 cross-tenant leak checks, all of which must pass before code ships.`)
};

const id_mk_sec_pg_l1_n = /** @type {(inputs: Mk_Sec_Pg_L1_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diuji otomatis setiap rilis: 133 pemeriksaan kebocoran lintas perusahaan, semuanya harus lulus sebelum kode naik.`)
};

/**
* | output |
* | --- |
* | "Tested automatically every release: 133 cross-tenant leak checks, all of which must pass before code ships." |
*
* @param {Mk_Sec_Pg_L1_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_l1_n = /** @type {((inputs?: Mk_Sec_Pg_L1_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_L1_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_l1_n(inputs)
	return en_mk_sec_pg_l1_n(inputs)
});